import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LimitedEditionIcon from "src/assets/all-icons/limited-edition-icon.jsx";

import InventoryCard from '@/shared-components/cards/components/InventoryCard';
import ContractIcon from '@/shared-components/icons/components/new-icons/ContractIcon';
import EditIcon from '@/shared-components/icons/components/new-icons/EditIcon';

import ArtworkContract from './components/ArtworkContract';
import RequestLimitedEditions from './components/RequestLimitedEditions';

import './index.css';

export default function AvailableArtworkCard({ artworkData, onActivateLimitedEdition, onContractRenewalChange, onWithdrawArtwork }) {
  const [openLimitedEdition, setOpenLimitedEdition] = useState(false);
  const [openContract, setOpenContract] = useState(false);
  const navigate = useNavigate();
  const isAuctionEnabled = Boolean(artworkData?.artwork_auction?.is_enabled);

  return (
    <>
      <div className="available-artwork-card__container" onClick={()=>navigate(`/artwork/${artworkData.slug}`, { state: { from: true } })}>
        <InventoryCard artworkData={artworkData} type="artwork">
          <div className="available-artwork-card__icons">
            <LimitedEditionIcon className={`available-artwork-card__icon ${!artworkData.artwork_about.artwork_limited_edition ? "not-requested" : ""}`} onClick={e=>{e.stopPropagation(); setOpenLimitedEdition(true);}}/>

            <ContractIcon className="available-artwork-card__icon" onClick={e=>{e.stopPropagation(); setOpenContract(true);}}/>

            {!isAuctionEnabled && (
              <EditIcon
                className="available-artwork-card__icon"
                onClick={e => {
                  e.stopPropagation();
                  navigate("/profile/edit-artwork", { state: { from: true, artworkData } });
                }}
              />
            )}
          </div>
        </InventoryCard>
      </div>

      <RequestLimitedEditions
        open={openLimitedEdition}
        close={()=>setOpenLimitedEdition(false)}
        artworkData={artworkData}
        onActivateLimitedEdition={onActivateLimitedEdition}
        approved={Object.keys(artworkData?.artwork_limited_editions || {}).length > 0 }
      />

      <ArtworkContract
        open={openContract}
        close={()=>setOpenContract(false)}
        artworkData={artworkData}
        onContractRenewalChange={onContractRenewalChange}
        onWithdrawArtwork={onWithdrawArtwork}
      />
    </>
  );
}
